'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  allEvents: 'Tous les événements',
  audiences: 'Publics',
  clearFilters: 'Retirer tous les critères de recherche',
  contact: 'Contact',
  directions: 'Itinéraire',
  nextPage: 'Page suivante',
  noEvents: 'Aucun événement.',
  otherDates: 'autre date |||| autres dates',
  previousPage: 'Page précédente',
  price: 'Prix',
  save: 'Enregistrer',
  share: 'Partager',
  tags: 'Mots-clés',
  tickets: 'Billets',
  venueMap: 'Carte du lieu',
  weekOf: 'Semaine du',
  date: {
    from: 'du',
    to: 'au'
  },
  time: {
    rangeDelimiter: 'à'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/locales/fr.js
// module id = 704
// module chunks = 0